
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { fadeInVariants, slideInVariants } from '@/lib/animations';

const EmotionSummaryCards = () => {
  return (
    <motion.div 
      className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"
      variants={slideInVariants.up}
      initial="initial"
      animate="animate"
      transition={{ staggerChildren: 0.1 }}
    >
      <motion.div variants={fadeInVariants}>
        <Card className="overflow-hidden">
          <CardHeader className="pb-2 bg-gradient-to-r from-blue-50 to-white">
            <CardTitle className="text-xl">Média de Calma</CardTitle>
            <CardDescription>7 dias</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-3xl font-bold text-blue-500">5.4/10</div>
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-4 h-4 mr-1 rounded-full bg-green-500 text-white text-xs flex items-center justify-center">+</span>
              1.2 da semana anterior
            </p>
          </CardContent>
        </Card>
      </motion.div>
      
      <motion.div variants={fadeInVariants}>
        <Card className="overflow-hidden">
          <CardHeader className="pb-2 bg-gradient-to-r from-orange-50 to-white">
            <CardTitle className="text-xl">Nível de Estresse</CardTitle>
            <CardDescription>7 dias</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-3xl font-bold text-orange-500">5.0/10</div>
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-4 h-4 mr-1 rounded-full bg-green-500 text-white text-xs flex items-center justify-center">-</span>
              0.5 da semana anterior
            </p>
          </CardContent>
        </Card>
      </motion.div>
      
      <motion.div variants={fadeInVariants}>
        <Card className="overflow-hidden">
          <CardHeader className="pb-2 bg-gradient-to-r from-green-50 to-white">
            <CardTitle className="text-xl">Felicidade</CardTitle>
            <CardDescription>7 dias</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-3xl font-bold text-green-500">6.0/10</div>
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-4 h-4 mr-1 rounded-full bg-green-500 text-white text-xs flex items-center justify-center">+</span>
              0.8 da semana anterior
            </p>
          </CardContent>
        </Card>
      </motion.div>
    </motion.div>
  );
};

export default EmotionSummaryCards;
